import * as React from 'react';
import { Observer } from '../../../SharedContent/Observer'
import { SfCustomerModel } from '../../../SharedContent/SfCustomerModel'
import { SfProductReviewsJsonStruct, SfProductReviewsRequest, ProductReviewsPage } from '../../../SharedContent/SfProductReviewsJsonStruct'
import { ProductReviewsFilteredData, SfProductReviewsRawData } from '../../../SharedContent/ProductReviewsFilteredData'
import { ServiceModel, SfConfigModel } from '../../../SharedContent/ServiceClass'
import { TruncateComponentReact } from '../../SharedComponents/TruncateComponentReact';
import ProductReviewsJsonStruct = require("../../../SharedContent/SfProductReviewsJsonStruct");
import ProductReviewVoteRequest = ProductReviewsJsonStruct.ProductReviewVoteRequest;

export class ReviewsComponentReact extends React.Component<any, any>{

    private static readonly GetReviewsUrl = "webservicesCORE1/product/GetReviews";

    private static readonly VoteOnReviewUrl = "webservicesCORE1/SfCustomerActions/VoteOnReview";

    constructor(props: any) {
        super(props);
        this.state = {
            value: null,
            isLoggedIn: false,
            renderData: false,
            dataIsLoaded: false,
            stateObserver: Observer,
            sfCustomer: SfCustomerModel,
            ProdReviews: SfProductReviewsJsonStruct,
            descriptionPanelSizeSelectorClass: "description__text--small",
            IsMobileDevice: true,

        };
        this.setPageIndex_CLICK = this.setPageIndex_CLICK.bind(this);
        this.voteReviewUp_CLICK = this.voteReviewUp_CLICK.bind(this);
    }

    _prodReviews: SfProductReviewsJsonStruct | undefined;
    _config: SfConfigModel = new SfConfigModel();
    _serviceModel: ServiceModel = new ServiceModel();
    _windowWidth: number;
    _windowHeight: number;
    _IsMobileDevice: boolean = true;

    componentWillMount() {
        (window as any).ReviewsComponentReact = this;
    }
    componentDidMount() {

        this.setDataOnInit();
        //this.initObserverAndSubscribeToSfCustomerSubject();

    }

    openPanel_CLICK() {

    }

    closePanel_CLICK() {

    }

    previousPage_CLICK(evt, location:string="top") {
        var pageIndex = this._prodReviews.CurrentSelectedPage.PageId;
        if (pageIndex > 1) {
            this.setPageIndex(pageIndex - 1, location);
        }
    }

    nextPage_CLICK(evt, location:string="top") {
        //var pageData = this._prodReviews.ProdReviewsPages;
        var pageIndex = this._prodReviews.CurrentSelectedPage.PageId; //this.state.ProdReviews.CurrentSelectedPage.PageId;
        var pageCount = this.state.ProdReviews.ProdReviewsPages.length;
        if (pageCount > 0 && pageIndex < pageCount) {
            this.setPageIndex(pageIndex + 1, location);   
        }
    }

    setPageIndex_CLICK(page: any, location:string="top") {
        this.setPageIndex(page.PageId, location);
    }

    reviewsSort_CHANGE(evt, location:string="top") {
        var selection = evt.target.value;
        if (selection == 1) {
            this._prodReviews.ProdReviewsRequest.mostRecent = true;
        } else {
            this._prodReviews.ProdReviewsRequest.mostRecent = false;
        }
        this._prodReviews.CurrentSelectedPage = new ProductReviewsPage(1);
        this._prodReviews.ProdReviewsRequest.CurrentPageSelected = this._prodReviews.CurrentSelectedPage;
        this.loadData(this._prodReviews.ProdReviewsRequest);

        if(location === 'bottom'){
            (window as any ).scrollToTopOfReviews_CLICK();
        }

    }

    voteReviewUp_CLICK(prodReview: SfProductReviewsRawData) {
        if(!prodReview.CURRENT_USER_VOTED){
            var headerMiddleware = (window as any).$HeaderMiddleware

            if (headerMiddleware.SfCustomer !== undefined && headerMiddleware.SfCustomer.LoggedIn) {
                //TODO: make a call to the back-end
                this.postDataPromise(
                    new ProductReviewVoteRequest(
                        prodReview.PRODUCT_REVIEW_ID, headerMiddleware.SfCustomer.CustomerID),
                    this._config.GetBaseUrl() + ReviewsComponentReact.VoteOnReviewUrl)
                    .then((response) => {
                        if (response.success) {
                            prodReview.VOTED_UP++;
                        }
                        this.setState({
                            ProdReviews: this._prodReviews
                        }); 
                    });
                prodReview.CURRENT_USER_VOTED = true;
            } else {
                headerMiddleware.MyAccountMiddleware.myAccount_RevealLogin_CLICK();
            }
        }

        //TODO: there is no back-end functionality implemented yet
    }

    setPageIndex(pageId: number, location:string="top") {
        //var currentPage = this._prodReviews.CurrentSelectedPage as ProductReviewsPage;
        if (pageId && pageId !== this._prodReviews.CurrentSelectedPage.PageId) {
            this._prodReviews.CurrentSelectedPage.PageId = pageId;
            this._prodReviews.ProdReviewsRequest.CurrentPageSelected = this._prodReviews.CurrentSelectedPage;
            this.loadData(this._prodReviews.ProdReviewsRequest);
        }
        if(location === 'bottom'){
            (window as any ).scrollToTopOfReviews_CLICK();
        }
    }


    setPanelSizeClass(txtPanelSizeClass: string) {
        if (txtPanelSizeClass !== undefined && txtPanelSizeClass !== "") {
            this.setState({
                descriptionPanelSizeSelectorClass: txtPanelSizeClass
            })
        }

    }

    setDataOnInit() {
        var prodMainWrapper = this.get_Prod();
        //(storeFrontId: number, productId: number, isRestricted: boolean, avgReviewScore: number, totReviews: number)
        this._prodReviews =
            new SfProductReviewsJsonStruct(prodMainWrapper.STORE_FRONT_ID,
                prodMainWrapper.PRODUCT_ID,
                this._config.get_IsRestrictedSite(),
                prodMainWrapper.prodMain.SfProductEssentials.AVERAGE_REVIEW_SCORE,
                prodMainWrapper.prodMain.SfProductEssentials.TOTAL_REVIEWS);
        this.loadDataOnInit();
    }

    loadDataOnInit() {
        var prodMainWrapper = this.get_Prod();
        if (this._prodReviews.ReviewsFilteredData === undefined && prodMainWrapper.prodMain.SfProductEssentials.TOTAL_REVIEWS > 0) {

            if (prodMainWrapper.ProdReviews !== undefined) {
                this._prodReviews.ReviewsFilteredData = prodMainWrapper.ProdReviews.ProdReviewsFilteredData as ProductReviewsFilteredData;

                this._prodReviews.ProdReviewsPages = prodMainWrapper.ProdReviews.ProductReviewsPages;
                this._prodReviews.CurrentSelectedPage = prodMainWrapper.ProdReviews.ProdReviewsFilteredData.CurrentPage;
                this.setState({
                    ProdReviews: this._prodReviews,
                    dataIsLoaded: true
                })
            }
            //this.loadData(this._prodReviews.ProdReviewsRequest);
        }
    }
    loadData(sfProdReviewsRequest: SfProductReviewsRequest) {
        if (!(window as any).$sfConfigModel.IsRestrictedSite) {
            this.postDataPromise(sfProdReviewsRequest, this._config.GetBaseUrl() + ReviewsComponentReact.GetReviewsUrl)
                .then(result => {
                    this._prodReviews.ReviewsFilteredData = result;
                    if (this._prodReviews.ReviewsFilteredData !== undefined &&
                        this._prodReviews.ReviewsFilteredData.SfProductReviewsSorted!.length > 0) {


                        this._prodReviews.ProdReviewsPages = result.ProductReviewsPages;
                        this._prodReviews.CurrentSelectedPage = result.CurrentPage;
                        this.setState({
                            ProdReviews: this._prodReviews,
                            dataIsLoaded: true
                        })

                    }
                })
        }
    }

    get_Prod() {
        return (window as any).$prodMainWrapper;//.prodMain.SfProductEssentials.AVERAGE_REVIEW_SCORE
    }

    postDataPromise(data: any, url: string) {
        return fetch(url, {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            mode: "same-origin", // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json", // "Content-Type": "application/x-www-form-urlencoded",
            },
            body: JSON.stringify(data),
        })
            .then((response) => response.json())
            .then((result) => {
                return result;
            })
            .catch((error) => {
                console.error(error);
                return error;
            });

    }

    getDataPromise(url: string) {
        return fetch(url, {
            method: "GET", // *GET, POST, PUT, DELETE, etc.
            mode: "same-origin", // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "same-origin", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json", // "Content-Type": "application/x-www-form-urlencoded",
            },

        })
            .then((response) => response.json())
            .then((result) => {
                return result;
            })
            .catch((error) => {
                console.error(error);
                return error;
            });

    }

    localResizeObserver: Observer;
    initResizeObserverAndSubscribeToSubject() {
        this.localResizeObserver = new Observer();
        this.localResizeObserver.id = 18;
        this.localResizeObserver.name = "ReviewsReactResizeObserver"
        this.localResizeObserver.update = (suppliedContext) =>
            (window as any).ReviewsComponentReact.receiveNotification_ReviewsResizeObserver(suppliedContext);

        try {
            setTimeout(function (refObserver) {
                if ((window as any).$GlobalMiddleware) {
                    (window as any).SubscribeResize(refObserver);
                }
            }, 50, this.localResizeObserver);

        } catch (exception) {
            console.log(exception);
        }
    }
    receiveNotification_ReviewsResizeObserver(suppliedContext) {
        var self = this;
        if (suppliedContext) {
            setTimeout(function () {
                if (suppliedContext.windowWidth) {
                    if (suppliedContext.windowWidth > 639 && self._IsMobileDevice) {
                        self._IsMobileDevice = false;
                        self.setState({ IsMobileDevice: self._IsMobileDevice });
                    } else if (suppliedContext.windowWidth < 639 && !self._IsMobileDevice) {
                        self._IsMobileDevice = true;
                        self.setState({ IsMobileDevice: self._IsMobileDevice });
                    }
                }

            }, 50)

        }
    }

    render() {
        if (this.state.dataIsLoaded) {
            return this.getReviewsContentBody();
        }
        return this.getEmptyContnet();
    }
    getEmptyContnet() {
        return <></>;
    }



    getReviewsContentBody() {
        return <div id="product-review-body" className="reviews__body" >
            {this.getPaginationAndSortingToolbarContent("top")}
            <div className="reviews__list">
                <div className="reviewlist">
                    <React.Fragment>
                        {this.getReviewListContent(this.state.ProdReviews.ReviewsFilteredData.SfProductReviewsSorted)}
                    </React.Fragment>
                </div>
            </div>
            {this.getPaginationAndSortingToolbarContent("bottom")}


        </div>
    }
    getPaginationAndSortingToolbarContent(location: string) {
        return <div key={location} id={'review-toolbar-'+location} className="reviews__toolbar">
            {this.getPaginationContent(location)}
            <div id={'review-sort-'+location} className="reviews__sort">
                <label className="select__label" htmlFor="review-list-sort">{(window as any).stringResourcesReviews.SortBy}:&nbsp;</label>
                <select className="select" id="review-list-sort" onChange={(evt) => this.reviewsSort_CHANGE(evt, location)}>
                    <option value="0">{(window as any).stringResourcesReviews.MostHelpful}</option>
                    <option value="1">{(window as any).stringResourcesReviews.Newest}</option>
                </select>
            </div>
        </div>
    }
    

    getPaginationContent(location: string) {
        return <nav aria-label="Pagination" className="reviews__nav">
            <ul className="pagination">
                <li key={10000}>
                    <a href="javascript:void(0)"
                       onClick={(evt) => this.previousPage_CLICK(evt, location)}
                            className={this.state.ProdReviews.CurrentSelectedPage.PageId <= 1 ? 'pagination__disabled-item' : ''}
                            aria-label="Previous page">
                        {(window as any).$prodMainWrapper.STORE_FRONT_ID !== 519 &&
                            <span className="pagination-button-text">{(window as any).stringResourcesReviews.Previous}</span>
                        }
                        {(window as any).$prodMainWrapper.STORE_FRONT_ID === 519 &&
                            <svg xmlns="http://www.w3.org/2000/svg" id="arrow-prev" enable-background="new 0 0 64 64" height="512" viewBox="0 0 64 64" width="512"><path d="m37.379 12.552c-.799-.761-2.066-.731-2.827.069-.762.8-.73 2.066.069 2.828l15.342 14.551h-39.963c-1.104 0-2 .896-2 2s.896 2 2 2h39.899l-15.278 14.552c-.8.762-.831 2.028-.069 2.828.393.412.92.62 1.448.62.496 0 .992-.183 1.379-.552l17.449-16.62c.756-.755 1.172-1.759 1.172-2.828s-.416-2.073-1.207-2.862z" /></svg>
                        }
                    </a>
                </li>

                <React.Fragment>
                    {/* {this.getPageNumbers()} */}
                    {this.getPageNumbersMAP(this.state.ProdReviews.ProdReviewsPages,
                        this.state.ProdReviews.CurrentSelectedPage.PageId,
                        this.state.ProdReviews.ProdReviewsPages.length,
                        location)}

                </React.Fragment>

                <li key={10001}>
                    <a href="javascript:void(0)"
                       onClick={(evt) => this.nextPage_CLICK(evt, location)}
                            className={this.state.ProdReviews.ProdReviewsPages.length === this.state.ProdReviews.CurrentSelectedPage.PageId ? 'pagination__disabled-item' : ''}
                            aria-label="Next page">
                        {(window as any).$prodMainWrapper.STORE_FRONT_ID !== 519 &&
                            <span className="pagination-button-text">{(window as any).stringResourcesReviews.Next}</span>
                        }
                        {(window as any).$prodMainWrapper.STORE_FRONT_ID === 519 &&
                            <svg xmlns="http://www.w3.org/2000/svg" id="arrow-next" enable-background="new 0 0 64 64" height="512" viewBox="0 0 64 64" width="512"><path d="m37.379 12.552c-.799-.761-2.066-.731-2.827.069-.762.8-.73 2.066.069 2.828l15.342 14.551h-39.963c-1.104 0-2 .896-2 2s.896 2 2 2h39.899l-15.278 14.552c-.8.762-.831 2.028-.069 2.828.393.412.92.62 1.448.62.496 0 .992-.183 1.379-.552l17.449-16.62c.756-.755 1.172-1.759 1.172-2.828s-.416-2.073-1.207-2.862z" /></svg>
                        }
                    </a>
                </li>
            </ul>
        </nav>
    }



    getPageNumbersMAP(pageData: ProductReviewsPage[], pageIndex: number, pageCount: number, location: string) {
        var pageNumbersContent = [];
        //var pageData = this.state.ProdReviews.ProdReviewsPages;
        //var pageIndex = this.state.ProdReviews.CurrentSelectedPage.PageId;
        //var pageCount = this.state.ProdReviews.ProdReviewsPages.length;
        var i = 0;
        pageData.map(page => {
            if (this.truncatePagination(i)) {
                pageNumbersContent.push(
                    <li key={'Page_pagination-item_' + i} className="pagination-item">
                        <a href="javascript:void(0)"
                           aria-label="Page"
                            onClick={() => this.setPageIndex_CLICK(page, location)}
                            className={pageIndex === page.PageId ? 'pagination__current-item' : ''} >
                            {page.PageId}
                        </a>
                    </li>
                );
            }
            if (i + 1 === pageIndex) {
                pageNumbersContent.push(
                    <li key={'pagination-item--mobile_current-page_' + i} className="pagination-item--mobile current-page">
                        {page.PageId}
                        <span> of </span>
                    </li>);
            }
            if (i + 1 === pageCount) {
                pageNumbersContent.push(
                    <li key={'pagination-item--mobile_last-page_' + i} className="pagination-item--mobile last-page">
                        {page.PageId} 
                        <span> of </span>
                    </li>);
            }
            if (pageCount > 7) {
                if (pageIndex > 4 && i === 1) {
                    pageNumbersContent.push(
                        <li key={'pagination-truncate-icon_1_' + i} className="pagination-truncate-icon">
                            ...
                        </li>);
                }
                if (pageIndex < pageCount - 3 && i === pageCount - 2) {
                    pageNumbersContent.push(
                        <li key={'pagination-truncate-icon_2_' + i} className="pagination-truncate-icon">
                            ...
                        </li>);
                }


            }
            i++;
        })

        return pageNumbersContent;
    }

    truncatePagination(index) {
        var pageCount = this.state.ProdReviews.ProdReviewsPages.length;
        var pageIndex = this.state.ProdReviews.CurrentSelectedPage.PageId;
        if (pageCount > 7) {

            index += 1;

            // Show first 5 paginations when under page index of 4
            // This allows the menu pagination not to increase navs size
            if (pageIndex <= 4 && index <= 5) {
                return true;
            }

            // Show current and direct sibling pagination
            if (pageIndex > 3 && pageIndex < pageCount - 2) {
                for (let i = pageIndex - 1; i <= pageIndex + 1; i++) {
                    if (index === i) {
                        return true;
                    }
                }
            }

            // Show last 3 pagination when page index is within last three pages
            if (index >= pageCount - 4 && pageIndex >= pageCount - 3) {
                return true;
            }

            // Show first pagination
            if (index === 1) {
                return true;
            }

            // Show last page pagination
            if (index === pageCount) {
                return true;
            }
            return false;
        }
        return true;
    }

    getReviewListContent(sfProductReviewsSorted: SfProductReviewsRawData[]) {

        var reviewList = [];
        var reviewLang = "";

        sfProductReviewsSorted.map(prodReview => {
            reviewList.push(
                <div className="review" key={prodReview.PRODUCT_REVIEW_ID}>
                    <h4 className="review__title">{prodReview.TITLE}</h4>
                    {/* <stars setStarRating={{prodReview.PRODUCT_REVIEW_SCORE}} setStarSize="small"></stars> */}
                    {this.getStartContent(prodReview.PRODUCT_REVIEW_SCORE)}
                    <p className="review__date">

                        {(window as any).stringResourcesReviews.By} {prodReview.FIRST_NAME} {(window as any).stringResourcesReviews.On} {prodReview.REVIEW_DATE_UIFormatted}

                        {
                            prodReview.VerifiedPurchase ?
                                <span className="review__verified">
                                    <ul className="review__verified--checkmark">
                                        <li></li>
                                    </ul>
                                    {(window as any).stringResourcesReviews.verifiedPurchase}
                                </span> :
                                <span></span>
                        }
                        {
                            prodReview.VerifiedPurchase && prodReview.MachineTranslated ?
                                <span className="review__verfiedTranslated"> | </span> : 
                                <span></span>
                        }
                        {
                            prodReview.MachineTranslated ? 
                                <span className="review__translated">{(window as any).eval("stringResourcesReviews.machineTranslatedFrom" + prodReview.Language)}</span> :
                                <span></span>
                        }
                        
                    </p>

                    <p className="review__body">
                        {/* <truncate truncateContent="{{prodReview.USER_COMMENT}}"
                                              truncateHeightThreshold=100
                                              showMoreText="Show More"
                                              showLessText="Show Less"></truncate> */}
                        {/* {prodReview.USER_COMMENT} */}
                        <React.Fragment>
                            {this.getTruncateComponent(prodReview)}
                        </React.Fragment>


                    </p>
                    <p className="review__helpful">
                        <span>{(window as any).stringResourcesReviews.WasThisReviewHelpfulToYou}</span>
                        <span className="review__helpful-wrap">
                            <button className="review_helpful-btn button button--green button--small"
                                onClick={() => this.voteReviewUp_CLICK(prodReview)}>{(window as any).stringResourcesReviews.Yes}</button>
                            <span className="review__helpful-count">{prodReview.VOTED_UP}</span>
                        </span>
                    </p>
                </div>
            )
        })

        return reviewList;
    }
    getStartContent(prodReviewScore:number){

        return <>
            {(window as any).$prodMainWrapper.STORE_FRONT_ID !== 519 &&
                <div className="review__stars stars stars--this.starSize stars--small">
                    <div className="stars__fill" style={{ width: this.getSetStarWidthForStyle(prodReviewScore) }}></div>
                    <div className="stars__hover" style={{ width: "0%" }}></div>
                    <div className="stars__overlay">
                        <img src="imgs/ratingStars/star-small.png" />
                        <img src="imgs/ratingStars/star-small.png" />
                        <img src="imgs/ratingStars/star-small.png" />
                        <img src="imgs/ratingStars/star-small.png" />
                        <img src="imgs/ratingStars/star-small.png" />
                    </div>
                </div>
            }
            {(window as any).$prodMainWrapper.STORE_FRONT_ID === 519 &&
                <div className="review__stars stars stars--this.starSize stars--small">
                    <div className="stars__fill" style={{ width: this.getSetStarWidthForStyle(prodReviewScore) }}></div>
                    <div className="stars__hover" style={{ width: "0%" }}></div>
                    <div className="stars__overlay">
                    <svg viewBox="0 0 960.87 871"><path d="M905.87,0H0V871H960.87V0ZM889.55,351Q768.21,439.18,646.82,527.31c-3.4,2.46-3.8,4.45-2.54,8.3Q692.76,684.32,741,833.13c.4,1.24.66,2.53,1.27,4.85-4.64-3.27-8.47-5.91-12.23-8.64Q607.2,740.14,484.47,650.83c-3.16-2.3-5-1.81-7.84.25Q351.3,742.4,225.85,833.58c-1.89,1.38-3.84,2.69-6.78,4.74,3.41-10.68,6.43-20.27,9.54-29.83q44.29-136.23,88.74-272.43c1.45-4.44.41-6.38-3.12-8.93Q188.41,436,62.79,344.63c-1.35-1-2.64-2.05-5.24-4.07h7q155.15,0,310.29.06c4.43,0,6.41-1.09,7.81-5.43q48-148.59,96.34-297.1c.44-1.36,1-2.68,1.94-5.2,2.33,7,4.3,12.86,6.21,18.73q46.1,141.76,92.09,283.58c1.3,4,2.94,5.47,7.29,5.46q154.89-.23,309.78-.15a13.49,13.49,0,0,1,6.11,1C898.11,344.68,893.85,347.84,889.55,351Z" /></svg>
                    <svg viewBox="0 0 960.87 871"><path d="M905.87,0H0V871H960.87V0ZM889.55,351Q768.21,439.18,646.82,527.31c-3.4,2.46-3.8,4.45-2.54,8.3Q692.76,684.32,741,833.13c.4,1.24.66,2.53,1.27,4.85-4.64-3.27-8.47-5.91-12.23-8.64Q607.2,740.14,484.47,650.83c-3.16-2.3-5-1.81-7.84.25Q351.3,742.4,225.85,833.58c-1.89,1.38-3.84,2.69-6.78,4.74,3.41-10.68,6.43-20.27,9.54-29.83q44.29-136.23,88.74-272.43c1.45-4.44.41-6.38-3.12-8.93Q188.41,436,62.79,344.63c-1.35-1-2.64-2.05-5.24-4.07h7q155.15,0,310.29.06c4.43,0,6.41-1.09,7.81-5.43q48-148.59,96.34-297.1c.44-1.36,1-2.68,1.94-5.2,2.33,7,4.3,12.86,6.21,18.73q46.1,141.76,92.09,283.58c1.3,4,2.94,5.47,7.29,5.46q154.89-.23,309.78-.15a13.49,13.49,0,0,1,6.11,1C898.11,344.68,893.85,347.84,889.55,351Z" /></svg>
                    <svg viewBox="0 0 960.87 871"><path d="M905.87,0H0V871H960.87V0ZM889.55,351Q768.21,439.18,646.82,527.31c-3.4,2.46-3.8,4.45-2.54,8.3Q692.76,684.32,741,833.13c.4,1.24.66,2.53,1.27,4.85-4.64-3.27-8.47-5.91-12.23-8.64Q607.2,740.14,484.47,650.83c-3.16-2.3-5-1.81-7.84.25Q351.3,742.4,225.85,833.58c-1.89,1.38-3.84,2.69-6.78,4.74,3.41-10.68,6.43-20.27,9.54-29.83q44.29-136.23,88.74-272.43c1.45-4.44.41-6.38-3.12-8.93Q188.41,436,62.79,344.63c-1.35-1-2.64-2.05-5.24-4.07h7q155.15,0,310.29.06c4.43,0,6.41-1.09,7.81-5.43q48-148.59,96.34-297.1c.44-1.36,1-2.68,1.94-5.2,2.33,7,4.3,12.86,6.21,18.73q46.1,141.76,92.09,283.58c1.3,4,2.94,5.47,7.29,5.46q154.89-.23,309.78-.15a13.49,13.49,0,0,1,6.11,1C898.11,344.68,893.85,347.84,889.55,351Z" /></svg>
                    <svg viewBox="0 0 960.87 871"><path d="M905.87,0H0V871H960.87V0ZM889.55,351Q768.21,439.18,646.82,527.31c-3.4,2.46-3.8,4.45-2.54,8.3Q692.76,684.32,741,833.13c.4,1.24.66,2.53,1.27,4.85-4.64-3.27-8.47-5.91-12.23-8.64Q607.2,740.14,484.47,650.83c-3.16-2.3-5-1.81-7.84.25Q351.3,742.4,225.85,833.58c-1.89,1.38-3.84,2.69-6.78,4.74,3.41-10.68,6.43-20.27,9.54-29.83q44.29-136.23,88.74-272.43c1.45-4.44.41-6.38-3.12-8.93Q188.41,436,62.79,344.63c-1.35-1-2.64-2.05-5.24-4.07h7q155.15,0,310.29.06c4.43,0,6.41-1.09,7.81-5.43q48-148.59,96.34-297.1c.44-1.36,1-2.68,1.94-5.2,2.33,7,4.3,12.86,6.21,18.73q46.1,141.76,92.09,283.58c1.3,4,2.94,5.47,7.29,5.46q154.89-.23,309.78-.15a13.49,13.49,0,0,1,6.11,1C898.11,344.68,893.85,347.84,889.55,351Z" /></svg>
                    <svg viewBox="0 0 960.87 871"><path d="M905.87,0H0V871H960.87V0ZM889.55,351Q768.21,439.18,646.82,527.31c-3.4,2.46-3.8,4.45-2.54,8.3Q692.76,684.32,741,833.13c.4,1.24.66,2.53,1.27,4.85-4.64-3.27-8.47-5.91-12.23-8.64Q607.2,740.14,484.47,650.83c-3.16-2.3-5-1.81-7.84.25Q351.3,742.4,225.85,833.58c-1.89,1.38-3.84,2.69-6.78,4.74,3.41-10.68,6.43-20.27,9.54-29.83q44.29-136.23,88.74-272.43c1.45-4.44.41-6.38-3.12-8.93Q188.41,436,62.79,344.63c-1.35-1-2.64-2.05-5.24-4.07h7q155.15,0,310.29.06c4.43,0,6.41-1.09,7.81-5.43q48-148.59,96.34-297.1c.44-1.36,1-2.68,1.94-5.2,2.33,7,4.3,12.86,6.21,18.73q46.1,141.76,92.09,283.58c1.3,4,2.94,5.47,7.29,5.46q154.89-.23,309.78-.15a13.49,13.49,0,0,1,6.11,1C898.11,344.68,893.85,347.84,889.55,351Z" /></svg>
                    </div>
                </div>
            }
        </>
    }
    getSetStarWidthForStyle(starRating: number) {
        return starRating * 20 + '%';
    }


    getTruncateComponent(prodReview: SfProductReviewsRawData) {
        return <TruncateComponentReact
            truncateHeightThreshold={100}
            truncateContent={prodReview.USER_COMMENT}
            showMoreText={"Show More"}
            showLessText={"Show Less"}>

        </TruncateComponentReact>
    }

    getTruncateFunction(prodReview: SfProductReviewsRawData) {
        return <TruncateFuncReact
            truncateHeightThreshold={100}
            truncateContent={prodReview.USER_COMMENT}
            showMoreText={"Show More"}
            showLessText={"Show Less"}
            Truncated={false}
            TruncateHeight={'100px'}
            TruncateOverlayHeight={'40px'}>
            <span style={{ whiteSpace: 'pre-line' }}>{this.toPlainText(prodReview.USER_COMMENT)}</span>
        </TruncateFuncReact>
    }

    // Review text is customer input, so it is shown as plain text rather than injected as HTML (it was
    // rendered with dangerouslySetInnerHTML, so an approved review containing markup or script would
    // run on the product page). Line breaks are kept, and entities such as &amp; in older reviews are
    // decoded. DOMParser builds an inert document - no scripts run, no images load, no handlers fire.
    toPlainText(value: string): string {
        if (!value) return '';
        const withLineBreaks = value.replace(/<br\s*\/?>/gi, '\n');
        return new DOMParser().parseFromString(withLineBreaks, 'text/html').body.textContent || '';
    }




}
function TruncateFuncReact(props) {

    return <div className={!props.Truncated ? 'truncate__content' : 'truncate__content truncate'}
        style={!props.Truncated ? { height: 'auto' } : { height: props.TruncateHeight }}>

        <div className={props.ShowTruncate ? 'truncate__wrapper' : ' '}>
            {props.children}
            {/* <span>
                    {props.truncateContent}
                </span> */}

        </div>

        {(props.ShowTruncate &&
            <div className="truncate__overlay" style={{ height: props.TruncateOverlayHeight }}></div>
        )}


    </div>
}

// function TruncateComponent(props){
//     return <div className="truncate__content" style={props.}>

//     </div>
// }


